import { FormField } from "@/components/ui/form";
import { cn } from "@/lib/utils";
import { ReadShiftReportDepartmentEntry } from "@/types/shiftReportDepartmentEntry";
import { Row } from "@tanstack/react-table";
import { useFormState, useWatch } from "react-hook-form";
import { hasEntryEnoughEmployees } from "../utils/hasEntryEnoughEmployees";
import { NumberInput } from "@/components/ui/NumberInput";

interface ShiftReportEntryCellInputNumberProps {
  row: Row<ReadShiftReportDepartmentEntry>;
  name: string;
}

const ShiftReportEntryCellInputNumber = ({
  row,
  name,
}: ShiftReportEntryCellInputNumberProps) => {
  const index = row.index;
  const formState = useFormState();
  const entry = useWatch({
    name: `department_entries.${row.index}`,
  });
  const error = !hasEntryEnoughEmployees(entry);

  return (
    <FormField
      name={`department_entries.${index}.${name}`}
      render={({ field }) => (
        <div className="relative">
          <NumberInput
            {...field}
            disabled={formState.isSubmitting}
            className={cn("text-center h-8", {
              "border-red-700": error,
            })}
            value={field.value == null ? "" : field.value}
            onChange={(e) => {
              const value = e.target.value;
              field.onChange(value === "" ? null : Number(value));
            }}
          />
        </div>
      )}
    />
  );
};

export default ShiftReportEntryCellInputNumber;
